import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import UserContext from "../auth/UserContext";
import ProfileDetail from "../profile/ProfileDetail";
import "./HomePage.css";
import logo from "../images/ParkPilotLogo.PNG";

const HomePage = () => {
    const { token, userDetail, logout } = useContext(UserContext);

    function HeroContent({ isLoggedIn }) {
        return (
            <div>
                <img
                    src={logo}
                    alt="logo"
                />

                <div className="text-center card card-body bg-light homepage-hero-card">
                    <p className="mb-3">Real-time valet operations, vehicle flow, and analytics in one dashboard.</p>

                    <div className="homepage-badges mb-3">
                        <span className="homepage-badge">Live Garage State</span>
                        <span className="homepage-badge">Role-Based Access</span>
                        <span className="homepage-badge">Survey + Activity Reporting</span>
                    </div>

                    {isLoggedIn ? (
                        <>
                            {userDetail ? (
                                <ProfileDetail userDetail={userDetail} />
                            ) : (
                                <div
                                    className="spinner-border text-primary"
                                    role="status">
                                    <span className="visually-hidden"></span>
                                </div>
                            )}

                            <div className="homepage-cta-row mt-3">
                                <Link
                                    className="btn me-2"
                                    to="/garage">
                                    Open Garage
                                </Link>
                                <Link
                                    className="btn me-2"
                                    to="/dashboard">
                                    Dashboard
                                </Link>
                                <Button
                                    color="danger"
                                    onClick={logout}
                                    size="sm">
                                    Logout
                                </Button>
                            </div>
                        </>
                    ) : (
                        <div className="homepage-cta-row">
                            <Link
                                className="btn me-2"
                                to="/login">
                                Sign In
                            </Link>
                            <Link
                                className="btn"
                                to="/registerWithInvite">
                                Create Account
                            </Link>
                            <br></br>
                            <br></br>
                            <a
                                href="https://www.youtube.com/channel/UClHH5ypytPOyBHmKFYhVYQg"
                                title="valet icons"
                                target="_blank"
                                rel="noopener noreferrer">
                                YouTube University
                            </a>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <section className="homepage-center">
            {/* <img
                src={logo}
                alt="logo"
                height="300"
            /> */}
            <HeroContent isLoggedIn={Boolean(token)} />
        </section>
    );
};

export default HomePage;
